import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Label } from '@/components/ui/label'
import { IntegrationSource } from '@super/shared-types'

interface PMSSelectorProps {
  value: IntegrationSource | ''
  onValueChange: (value: IntegrationSource | '') => void
  disabled?: boolean
}

export function PMSSelector({
  value,
  onValueChange,
  disabled = false,
}: PMSSelectorProps) {
  return (
    <div>
      <Label htmlFor="pms">Property Management System</Label>
      <Select
        value={value}
        onValueChange={(value: IntegrationSource) => onValueChange(value)}
        disabled={disabled}
      >
        <SelectTrigger id="pms" className="mt-2">
          <SelectValue placeholder="Select PMS" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={IntegrationSource.APPFOLIO}>Appfolio</SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}
